export default __webpack_public_path__ + "static/media/c-introduce-item-img-03.f5bc5e4a.png";